import api from "./axios";
const knowledgeAPI = {

    async getAll() {

        const response = await api.get("/knowledge");

        return response.data;

    },

    async getById(id) {

        const response = await api.get(`/knowledge/${id}`);

        return response.data;

    },

    async getCategories() {

        const response = await api.get("/knowledge/categories");

        return response.data;

    },

    async search(query) {

        const response = await api.get("/knowledge/search", {

            params: {

                q: query

            }

        });

        return response.data;

    }

};

export default knowledgeAPI;